import { render, staticRenderFns } from "./IcoLightBulb.vue?vue&type=template&id=d1115d76"
import script from "./IcoLightBulb.vue?vue&type=script&lang=js"
export * from "./IcoLightBulb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports